var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Box" },
    [
      _c("div", { class: _vm.screenWidth >= 1030 ? "top_title" : "mt20" }, [
        _c("div", [
          _c("span", { staticClass: "top_title_top" }, [
            _vm._v(
              _vm._s(_vm.$t("collectionCenter.transitCenterInventoryDashboard"))
            ),
          ]),
          _c("br"),
          _c("span", { staticClass: "top_title_bottom" }, [
            _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal1"))),
          ]),
        ]),
        _c("div", { staticClass: "top_title_time" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("collectionCenter.hubVal2")) +
              "：" +
              _vm._s(_vm.updateTime || "--") +
              " "
          ),
          _c("span", { staticClass: "top_title_time_split" }, [_vm._v("|")]),
          _vm._v(" " + _vm._s(_vm.$t("collectionCenter.hubVal3"))),
        ]),
      ]),
      _c(
        "el-form",
        { staticClass: "form_box" },
        [
          _c(
            "el-row",
            {
              staticStyle: { "flex-wrap": "wrap", gap: "10px" },
              attrs: { type: "flex", justify: "left" },
            },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.screenWidth >= 1030 ? 5 : 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("collectionCenter.region") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("collectionCenter.allRegions"),
                            clearable: "",
                            filterable: "",
                            size: "small",
                          },
                          on: { change: _vm.changeRegion },
                          model: {
                            value: _vm.queryForm.params.areaNameList,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "areaNameList",
                                $$v
                              )
                            },
                            expression: "queryForm.params.areaNameList",
                          },
                        },
                        _vm._l(_vm.regionData, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.zhName + "（" + item.puName + "）",
                              value: item.zhName,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.screenWidth >= 1030 ? 5 : 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("collectionCenter.state") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("collectionCenter.allStates"),
                            clearable: "",
                            filterable: "",
                            multiple: "",
                            "collapse-tags": "",
                            size: "small",
                          },
                          on: { change: _vm.changeState },
                          model: {
                            value: _vm.queryForm.params.stateList,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "stateList", $$v)
                            },
                            expression: "queryForm.params.stateList",
                          },
                        },
                        _vm._l(_vm.stateData, function (item, idx) {
                          return _c("el-option", {
                            key: idx,
                            attrs: { label: item.label, value: item.label },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.screenWidth >= 1030 ? 5 : 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.transitCenterType"),
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("collectionCenter.allTypes"),
                            clearable: "",
                            filterable: "",
                            size: "small",
                          },
                          model: {
                            value: _vm.queryForm.params.hubLevelList,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "hubLevelList",
                                $$v
                              )
                            },
                            expression: "queryForm.params.hubLevelList",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("collectionCenter.hubVal28"),
                              value: "lv1",
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("collectionCenter.hubVal29"),
                              value: "lv2",
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("collectionCenter.hubVal30"),
                              value: "lv3",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.screenWidth >= 1030 ? 5 : 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.transferCenter"),
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("collectionCenter.hubVal31"),
                            clearable: "",
                            filterable: "",
                            multiple: "",
                            "collapse-tags": "",
                            size: "small",
                          },
                          model: {
                            value: _vm.queryForm.params.departmentList,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "departmentList",
                                $$v
                              )
                            },
                            expression: "queryForm.params.departmentList",
                          },
                        },
                        _vm._l(_vm.departmentData, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.name },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.screenWidth >= 1030 ? 2 : 24 } },
                [
                  _c(
                    "el-button",
                    {
                      class: _vm.screenWidth >= 1030 ? "search_btn" : "allW",
                      staticStyle: { "box-shadow": "0 0 0 #fff" },
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.searchForm },
                    },
                    [_vm._v(_vm._s(_vm.$t("collectionCenter.search")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "title_bw" }, [
        _c("span", { staticClass: "title_bw_bold ind" }, [
          _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal4"))),
        ]),
        _c("span", { staticClass: "title_bw_tips" }, [
          _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal5"))),
        ]),
      ]),
      _c(
        "div",
        { class: _vm.screenWidth >= 1030 ? "grid-seven" : "" },
        _vm._l(_vm.globalOverviewData, function (item, i) {
          return _c(
            "div",
            { key: i, class: _vm.screenWidth >= 1030 ? "grid-item7" : "gi7" },
            [
              _c("span", { staticClass: "grid_item_gray" }, [
                _vm._v(_vm._s(item.data1)),
              ]),
              _c("br"),
              _c(
                "span",
                { staticClass: "grid_item_bold", style: { color: item.color } },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.globalOverviewValue[item.data2]
                          ? _vm.formatThousand(
                              _vm.globalOverviewValue[item.data2]
                            )
                          : 0
                      ) +
                      " " +
                      _vm._s(
                        item.data2 === "stockTurnoverDays"
                          ? _vm.$t("orderCenterCont.days")
                          : item.data2 === "avgInventoryHours"
                          ? "h"
                          : item.data2 === "inventoryAgingRate"
                          ? "%"
                          : ""
                      ) +
                      " "
                  ),
                ]
              ),
              _c("br"),
              _c("span", { staticClass: "grid_item_gray" }, [
                _vm._v(_vm._s(item.data3)),
              ]),
            ]
          )
        }),
        0
      ),
      _c("div", { staticClass: "title_bw" }, [
        _c("span", { staticClass: "title_bw_bold ind" }, [
          _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal6"))),
        ]),
        _c("span", { staticClass: "title_bw_tips" }, [
          _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal7"))),
        ]),
      ]),
      _c(
        "el-row",
        { style: _vm.screenWidth >= 1030 ? "display: flex;gap: 10px" : "" },
        [
          _c(
            "el-col",
            {
              staticClass: "box_class",
              attrs: { span: _vm.screenWidth >= 1030 ? 13 : 24 },
            },
            [
              _c("span", { staticClass: "title_bw_bold" }, [
                _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal8"))),
              ]),
              _c("br"),
              _c("span", { staticClass: "title_bw_tips" }, [
                _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal9"))),
              ]),
              _c(
                "div",
                { staticClass: "grid-five" },
                _vm._l(_vm.ageStructureData, function (item, i) {
                  return _c(
                    "div",
                    {
                      key: i,
                      class: _vm.screenWidth >= 1030 ? "grid-item5" : "gi5",
                      style: {
                        background: item.background,
                        "border-color": item.borderColor,
                      },
                    },
                    [
                      _c("span", { staticClass: "grid_item_gray" }, [
                        _vm._v(_vm._s(item.bucketName)),
                      ]),
                      _c("br"),
                      _c("span", { staticClass: "grid_item_bold" }, [
                        _vm._v(
                          _vm._s(_vm.formatThousand(item.ticketCount) || 0)
                        ),
                      ]),
                      _c("br"),
                      _c("span", { staticClass: "grid_item_gray" }, [
                        _vm._v(
                          _vm._s(_vm.formatThousand(item.rate) || 0) + "%"
                        ),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _c("div", { staticClass: "bg_box" }, [
                _c("span", {
                  staticClass: "bg_green",
                  style: {
                    width: _vm.lineData.length > 0 ? _vm.lineData[0] : 0,
                  },
                  on: {
                    mousemove: function ($event) {
                      return _vm.showEchartsTooltip(
                        $event,
                        _vm.ageStructureData[0],
                        "bg_green"
                      )
                    },
                    mouseleave: _vm.hideEchartsTooltip,
                  },
                }),
                _c("span", {
                  staticClass: "bg_blue",
                  style: {
                    width: _vm.lineData.length > 0 ? _vm.lineData[1] : 0,
                  },
                  on: {
                    mousemove: function ($event) {
                      return _vm.showEchartsTooltip(
                        $event,
                        _vm.ageStructureData[1],
                        "bg_blue"
                      )
                    },
                    mouseleave: _vm.hideEchartsTooltip,
                  },
                }),
                _c("span", {
                  staticClass: "bg_Pumpkin",
                  style: {
                    width: _vm.lineData.length > 0 ? _vm.lineData[2] : 0,
                  },
                  on: {
                    mousemove: function ($event) {
                      return _vm.showEchartsTooltip(
                        $event,
                        _vm.ageStructureData[2],
                        "bg_Pumpkin"
                      )
                    },
                    mouseleave: _vm.hideEchartsTooltip,
                  },
                }),
                _c("span", {
                  staticClass: "bg_orange",
                  style: {
                    width: _vm.lineData.length > 0 ? _vm.lineData[3] : 0,
                  },
                  on: {
                    mousemove: function ($event) {
                      return _vm.showEchartsTooltip(
                        $event,
                        _vm.ageStructureData[3],
                        "bg_orange"
                      )
                    },
                    mouseleave: _vm.hideEchartsTooltip,
                  },
                }),
                _c("span", {
                  staticClass: "bg_red",
                  style: {
                    width: _vm.lineData.length > 0 ? _vm.lineData[4] : 0,
                  },
                  on: {
                    mousemove: function ($event) {
                      return _vm.showEchartsTooltip(
                        $event,
                        _vm.ageStructureData[4],
                        "bg_red"
                      )
                    },
                    mouseleave: _vm.hideEchartsTooltip,
                  },
                }),
              ]),
              _c("div", { staticClass: "bg_card" }, [
                _c("span", [
                  _c("span", { staticClass: "bg_green color_card" }),
                  _vm._v(" ≤24h"),
                ]),
                _c("span", [
                  _c("span", { staticClass: "bg_blue color_card" }),
                  _vm._v(" 24~48h"),
                ]),
                _c("span", [
                  _c("span", { staticClass: "bg_Pumpkin color_card" }),
                  _vm._v(" 48~72h"),
                ]),
                _c("span", [
                  _c("span", { staticClass: "bg_orange color_card" }),
                  _vm._v(" 3~7" + _vm._s(_vm.$t("basicData.NumberOfDays"))),
                ]),
                _c("span", [
                  _c("span", { staticClass: "bg_red color_card" }),
                  _vm._v(" >7" + _vm._s(_vm.$t("basicData.NumberOfDays"))),
                ]),
              ]),
            ]
          ),
          _c(
            "el-col",
            {
              staticClass: "box_class",
              style: _vm.screenWidth < 1030 ? "margin-top: 10px" : "",
              attrs: { span: _vm.screenWidth >= 1030 ? 11 : 24 },
            },
            [
              _c("span", { staticClass: "title_bw_bold" }, [
                _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal10"))),
              ]),
              _c("br"),
              _c("span", { staticClass: "title_bw_tips" }, [
                _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal11"))),
              ]),
              _vm._l(_vm.levelData, function (item, i) {
                return _c(
                  "el-row",
                  { key: i, staticClass: "progress_class" },
                  [
                    _c(
                      "el-col",
                      { staticClass: "progress_title", attrs: { span: 4 } },
                      [_vm._v(_vm._s(item.title))]
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 16 } },
                      [
                        _c("el-progress", {
                          attrs: {
                            "stroke-width": 12,
                            "show-text": false,
                            color: "#ea580c",
                            percentage: item.progress,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { staticClass: "progress_num", attrs: { span: 3 } },
                      [
                        _vm._v(
                          _vm._s(_vm.formatThousand(item.currentTicketCount))
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
              _c("div", { staticClass: "progress_gray_box" }, [
                _c("span", { staticClass: "progress_gray_text" }, [
                  _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal12"))),
                ]),
                _vm._v(" " + _vm._s(_vm.$t("collectionCenter.hubVal13"))),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-row",
        {
          style:
            _vm.screenWidth >= 1030
              ? "display: flex;gap: 10px; margin-top: 10px"
              : "margin-top: 10px",
        },
        [
          _c(
            "el-col",
            {
              staticClass: "box_class",
              attrs: { span: _vm.screenWidth >= 1030 ? 11 : 24 },
            },
            [
              _c("span", { staticClass: "title_bw_bold" }, [
                _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal14"))),
              ]),
              _c("br"),
              _c("span", { staticClass: "title_bw_tips" }, [
                _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal15"))),
              ]),
              _vm.highRiskData && _vm.highRiskData.length > 0
                ? _c(
                    "ul",
                    { staticClass: "risk_box" },
                    _vm._l(_vm.highRiskData, function (item, i) {
                      return _c("li", { key: i, staticClass: "risk_item" }, [
                        _c("span", { staticClass: "risk_index" }, [
                          _vm._v(_vm._s(i + 1)),
                        ]),
                        _c("div", { staticClass: "risk_content" }, [
                          _c("span", { staticClass: "risk_name" }, [
                            _vm._v(_vm._s(item.hubName)),
                          ]),
                          _c("br"),
                          _c("span", { staticClass: "title_bw_tips" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("collectionCenter.hubVal16")) +
                                " " +
                                _vm._s(
                                  _vm.formatThousand(item.currentTicketCount) ||
                                    0
                                )
                            ),
                            _c("span", { staticClass: "risk_num" }, [
                              _vm._v("|"),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("collectionCenter.hubVal17")) +
                                " " +
                                _vm._s(
                                  _vm.formatThousand(
                                    item.avgDailyOutboundTicketCount
                                  ) || 0
                                )
                            ),
                          ]),
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "risk_day",
                            style: {
                              background:
                                item.stockTurnoverDays <= 1
                                  ? "#ecfdf3"
                                  : item.stockTurnoverDays <= 2
                                  ? "#fdf8ec"
                                  : item.stockTurnoverDays <= 3
                                  ? "#fffaeb"
                                  : "#fef3f2",
                              color:
                                item.stockTurnoverDays <= 1
                                  ? "#079455"
                                  : item.stockTurnoverDays <= 2
                                  ? "#dcca03"
                                  : item.stockTurnoverDays <= 3
                                  ? "#dc6803"
                                  : "#d92d20",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(item.stockTurnoverDays) +
                                _vm._s(_vm.$t("orderCenterCont.days"))
                            ),
                          ]
                        ),
                      ])
                    }),
                    0
                  )
                : _c(
                    "div",
                    {
                      staticStyle: {
                        margin: "20px auto",
                        color: "#909399",
                        "text-align": "center",
                        "font-size": "14px",
                      },
                    },
                    [
                      _vm._v(
                        " - " +
                          _vm._s(_vm.$t("collectionCenter.nullMsg")) +
                          " -"
                      ),
                    ]
                  ),
            ]
          ),
          _c(
            "el-col",
            {
              staticClass: "box_class",
              style: _vm.screenWidth < 1030 ? "margin-top: 10px" : "",
              attrs: { span: _vm.screenWidth >= 1030 ? 13 : 24 },
            },
            [
              _c("span", { staticClass: "title_bw_bold" }, [
                _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal18"))),
              ]),
              _c("br"),
              _c("span", { staticClass: "title_bw_tips" }, [
                _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal19"))),
              ]),
              _vm.agingRiskData && _vm.agingRiskData.length > 0
                ? _c(
                    "ul",
                    { staticClass: "risk_box" },
                    _vm._l(_vm.agingRiskData, function (item, i) {
                      return _c("li", { key: i, staticClass: "risk_item" }, [
                        _c("span", { staticClass: "risk_index" }, [
                          _vm._v(_vm._s(i + 1)),
                        ]),
                        _c("div", { staticClass: "risk_content " }, [
                          _c("span", { staticClass: "risk_name" }, [
                            _vm._v(_vm._s(item.hubName)),
                          ]),
                          _c("br"),
                          _c(
                            "span",
                            {
                              style: {
                                "font-weight": "bold",
                                "font-size": "14px",
                                color:
                                  item.inventoryAgingRate <= 5
                                    ? "#079455"
                                    : item.inventoryAgingRate <= 10
                                    ? "#dcca03"
                                    : item.inventoryAgingRate <= 20
                                    ? "#dc6803"
                                    : "#d92d20",
                              },
                            },
                            [_vm._v(_vm._s(item.inventoryAgingRate) + " %")]
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "title_bw_tips",
                            staticStyle: { "margin-right": "10px" },
                          },
                          [
                            _c(
                              "span",
                              { staticStyle: { "font-size": "12px" } },
                              [_vm._v("48~72h")]
                            ),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatThousand(
                                    item.inventory48To72hCount
                                  ) || 0
                                ) +
                                " "
                            ),
                            _c("span", { staticClass: "risk_num" }, [
                              _vm._v("|"),
                            ]),
                            _c(
                              "span",
                              { staticStyle: { "font-size": "12px" } },
                              [
                                _vm._v(
                                  "3~7" +
                                    _vm._s(_vm.$t("basicData.NumberOfDays"))
                                ),
                              ]
                            ),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatThousand(
                                    item.inventory3To7dCount
                                  ) || 0
                                ) +
                                " "
                            ),
                            _c("span", { staticClass: "risk_num" }, [
                              _vm._v("|"),
                            ]),
                            _c(
                              "span",
                              { staticStyle: { "font-size": "12px" } },
                              [
                                _vm._v(
                                  ">7" +
                                    _vm._s(_vm.$t("basicData.NumberOfDays"))
                                ),
                              ]
                            ),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatThousand(item.inventoryGt7dCount) ||
                                    0
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "risk_day",
                            style: {
                              background:
                                item.inventoryAgingRate <= 5
                                  ? "#ecfdf3"
                                  : item.inventoryAgingRate <= 10
                                  ? "#fdf8ec"
                                  : item.inventoryAgingRate <= 20
                                  ? "#fffaeb"
                                  : "#fef3f2",
                              color:
                                item.inventoryAgingRate <= 5
                                  ? "#079455"
                                  : item.inventoryAgingRate <= 10
                                  ? "#dcca03"
                                  : item.inventoryAgingRate <= 20
                                  ? "#dc6803"
                                  : "#d92d20",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.formatThousand(item.inventoryAgingCount)
                              )
                            ),
                          ]
                        ),
                      ])
                    }),
                    0
                  )
                : _c(
                    "div",
                    {
                      staticStyle: {
                        margin: "20px auto",
                        color: "#909399",
                        "text-align": "center",
                        "font-size": "14px",
                      },
                    },
                    [
                      _vm._v(
                        " - " +
                          _vm._s(_vm.$t("collectionCenter.nullMsg")) +
                          " -"
                      ),
                    ]
                  ),
            ]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "title_bw" }, [
        _c("span", { staticClass: "title_bw_bold ind" }, [
          _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal20"))),
        ]),
        _c("span", { staticClass: "title_bw_tips" }, [
          _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal21"))),
        ]),
      ]),
      _c("div", { staticClass: "box_class" }, [
        _c("span", { staticClass: "title_bw_tips" }, [
          _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal22"))),
        ]),
        Object.keys(_vm.barData).length > 0
          ? _c(
              "div",
              [_c("barChart", { attrs: { "chart-data": _vm.barData } })],
              1
            )
          : _c(
              "div",
              {
                staticStyle: {
                  margin: "20px auto",
                  color: "#909399",
                  "text-align": "center",
                  "font-size": "14px",
                },
              },
              [
                _vm._v(
                  " - " + _vm._s(_vm.$t("collectionCenter.nullMsg")) + " -"
                ),
              ]
            ),
      ]),
      _c(
        "div",
        {
          staticClass: "box_class",
          staticStyle: { "margin-top": "20px", padding: "0 !important" },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center",
                padding: "10px",
                "box-sizing": "border-box",
              },
            },
            [
              _c("div", [
                _c("span", { staticClass: "title_bw_bold" }, [
                  _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal23"))),
                ]),
                _c("br"),
                _c("span", { staticClass: "title_bw_tips" }, [
                  _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal24"))),
                ]),
              ]),
              _c(
                "div",
                { staticStyle: { float: "right" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.exportData("hubStockDetail")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("collectionCenter.hubVal25")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.exportData("hubStockRealtimeWaybillDetail")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("collectionCenter.exportDetails")))]
                  ),
                ],
                1
              ),
            ]
          ),
          _c("hubTable", { attrs: { "table-data": _vm.tableData } }),
        ],
        1
      ),
      _c("div", { staticClass: "progress_gray_box" }, [
        _c("span", { staticClass: "progress_gray_text" }, [
          _vm._v(_vm._s(_vm.$t("collectionCenter.hubVal26")) + "："),
        ]),
        _vm._v(" " + _vm._s(_vm.$t("collectionCenter.hubVal27")) + " "),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.barMsgVisible,
              expression: "barMsgVisible",
            },
          ],
          staticClass: "bartip_box",
          style: { left: _vm.tooltipX + "px", top: _vm.tooltipY + "px" },
        },
        [
          _c("div", { staticClass: "bartip_content" }, [
            _c("span", { staticClass: "color_card", class: _vm.barMsgColor }),
            _vm._v(" " + _vm._s(_vm.barMsgData.bucketName)),
          ]),
          _c("div", [
            _vm._v(
              _vm._s(_vm.$t("collectionCenter.ballot")) +
                "：" +
                _vm._s(_vm.formatThousand(_vm.barMsgData.ticketCount))
            ),
          ]),
          _c("div", [
            _vm._v(
              _vm._s(_vm.$t("trajectory.Proportion")) +
                "：" +
                _vm._s(_vm.formatThousand(_vm.barMsgData.rate)) +
                "%"
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }